import { Box, Button, TextField } from '@material-ui/core'
import React, { useState } from 'react'
import Modal from '../../components/modal/Modal'
import StatusCard from '../../components/status-card/StatusCard'
import ItemPriceUpdate from './product_priceUpdate'

const PriceUpdate = () => {
  const [showItemPriceUpdateView,setItemPriceUpdateView]=useState(false)
  return (
    <div className='flex justify-center w-full h-full items-center'>
           <div className="col-6">
          <StatusCard
            icon={"bx bxs-dollar-circle"}
            style={{height:300,minWidth:250, display:'flex', justifyContent:'center'}}
             onClick={()=>setItemPriceUpdateView(state=>!state)}
            title={"Individual Price Update"}
          ></StatusCard>
        </div>

        <div className="col-6">
          <StatusCard
            icon={"bx bxs-component"}
            style={{height:300, minWidth:450}}
            title={"Bulk Exchange Price Update "}
            subtitle={"only, available items will be effect , its will adjust all sell Price for Local not USD"}
          >
            <div><TextField name='exchange' placeholder='360'></TextField>
        <Button variant='contained' color='primary' name='exchangeRate'>Update</Button>
            
            </div>
          </StatusCard>
        </div>

        {/* <ItemPriceUpdate/> */}

        <Modal
        modal_title={"ITEM PRICE UPDATE"}
        canShow={showItemPriceUpdateView}
        updateModalState={() => {
          setItemPriceUpdateView(false);
        }}
      >
        <Box>
          <ItemPriceUpdate
            
          />
        </Box>
      </Modal>

    </div>
  )
}

export default PriceUpdate